import axiosInstance from "@/axios";

const createTag = (data) => axiosInstance.post("/api/profile/marks", data);

const editTag = (tagId, data) =>
  axiosInstance.patch(`/api/profile/marks/${tagId}`, data);

const deleteTag = (tagId) =>
  axiosInstance.delete(`/api/profile/marks/${tagId}`);

const updateTagPriority = (data) =>
  axiosInstance.patch("/api/profile/marks/priority", data);

const tagLots = (data) => axiosInstance.post("/api/profile/marks/lots", data);

const untagLots = (data) =>
  axiosInstance.delete("/api/profile/marks/lots", { data });

const getLotCount = (profileId) =>
  axiosInstance.get("/api/profile/marks/lot-count", { params: { profileId } });

export {
  createTag,
  editTag,
  deleteTag,
  updateTagPriority,
  tagLots,
  untagLots,
  getLotCount,
};
